import {assetDefaults} from '@netx/core-asset-next/defaults';
import {type IAsset} from '@netx/core-asset-next/schema';

export const createAssetObject = (overrides?: Partial<IAsset>): IAsset => ({
	assetId: 0,
	...assetDefaults,
	...overrides,
});

export default createAssetObject;
